import React from 'react';
import { Container } from 'react-bootstrap';
import { FiZap, FiGlobe, FiSmartphone, FiShield } from 'react-icons/fi';
import EsimSearchForm from '../../components/EsimSearchForm/EsimSearchForm';
import { DEFAULT_NATIONALITY } from '../../constants/esimConstants';
import './EsimLandingPage.scss';

const FEATURES = [
  {
    icon: <FiZap />,
    title: 'Instant Activation',
    description:
      'Scan the QR code we email you and your eSIM is online in seconds — no SIM swap.',
  },
  {
    icon: <FiGlobe />,
    title: '150+ Destinations',
    description:
      'Single-country, regional and global plans curated for both leisure and business travel.',
  },
  {
    icon: <FiSmartphone />,
    title: 'Keep Your Number',
    description:
      'Your home SIM stays active for calls and OTPs while data flows over the eSIM.',
  },
  {
    icon: <FiShield />,
    title: '24×7 Support',
    description:
      'Round-the-clock human support if you need help installing or topping up.',
  },
];

const HIGHLIGHTS = [
  '4G / LTE speeds across all major networks',
  'Tethering / hotspot allowed on most plans',
  'No paperwork — pay and go',
];

function EsimLandingPage() {
  return (
    <main className="esim-landing">
      <section className="esim-landing__hero">
        <Container>
          <div className="esim-landing__hero-grid">
            <div className="esim-landing__copy">
              <span className="esim-landing__eyebrow">eSIM for Travellers</span>
              <h1 className="esim-landing__heading">
                Travel light. <span>Stay connected.</span>
              </h1>
              <p className="esim-landing__lede">
                Pick a destination, choose your travel dates and get a curated
                set of eSIM data plans — delivered to your inbox the moment you
                book.
              </p>
              <ul className="esim-landing__highlights">
                {HIGHLIGHTS.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
            </div>

            <div className="esim-landing__form">
              <EsimSearchForm
                initialValues={{ nationality: DEFAULT_NATIONALITY.countryCode }}
              />
            </div>
          </div>
        </Container>
      </section>

      <section className="esim-landing__features">
        <Container>
          <h2 className="esim-landing__section-title">
            Why book your eSIM with us?
          </h2>
          <div className="esim-landing__features-grid">
            {FEATURES.map((f) => (
              <div key={f.title} className="esim-landing__feature">
                <div className="esim-landing__feature-icon">{f.icon}</div>
                <h3 className="esim-landing__feature-title">{f.title}</h3>
                <p className="esim-landing__feature-desc">{f.description}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="esim-landing__steps">
        <Container>
          <h2 className="esim-landing__section-title">How it works</h2>
          <ol className="esim-landing__step-list">
            <li>
              <span>1</span>
              <h4>Tell us where you&apos;re going</h4>
              <p>Choose your destination country and travel dates.</p>
            </li>
            <li>
              <span>2</span>
              <h4>Pick the right plan</h4>
              <p>Compare data, validity and pricing in a single view.</p>
            </li>
            <li>
              <span>3</span>
              <h4>Add traveller details</h4>
              <p>
                Share basic passport &amp; contact info — we keep it secure.
              </p>
            </li>
            <li>
              <span>4</span>
              <h4>Receive your eSIM</h4>
              <p>QR code is emailed instantly. Scan, install, travel.</p>
            </li>
          </ol>
        </Container>
      </section>
    </main>
  );
}

export default EsimLandingPage;
